export const COLOR_PALETTE = [
  {
    name: 'grey',
    hex: '#ebebeb',
    contrast: '#000'
  },
  {
    name: 'amber',
    hex: 'rgba(255, 193, 7, 0.40)',
    contrast: '#fff'
  },
  {
    name: 'blue',
    hex: '#0288d1',
    contrast: '#fff'
  },
  {
    name: 'blueGrey',
    hex: '#607d8b',
    contrast: '#fff'
  },
  {
    name: 'brown',
    hex: '#795548',
    contrast: '#fff'
  },
  {
    name: 'cyan',
    hex: '#00bcd4',
    contrast: '#000'
  },
  {
    name: 'deepOrange',
    hex: '#ff5722',
    contrast: '#000'
  },
  {
    name: 'deepPurple',
    hex: '#673ab7',
    contrast: '#fff'
  },
  {
    name: 'green',
    hex: '#4caf50',
    contrast: '#fff'
  },
  {
    name: 'indigo',
    hex: '#3f51b5',
    contrast: '#fff'
  },
  {
    name: 'lightBlue',
    hex: '#03a9f4',
    contrast: '#000'
  },
  {
    name: 'lightGreen',
    hex: '#8bc34a',
    contrast: '#000'
  },
  {
    name: 'lime',
    hex: '#cddc39',
    contrast: '#000'
  },
  {
    name: 'orange',
    hex: '#ff9800',
    contrast: '#000'
  },
  {
    name: 'pink',
    hex: '#e91e63',
    contrast: '#fff'
  },
  {
    name: 'purple',
    hex: '#9c27b0',
    contrast: '#fff'
  },
  {
    name: 'red',
    hex: '#f44336',
    contrast: '#fff'
  },
  {
    name: 'teal',
    hex: '#009688',
    contrast: '#fff'
  },
  {
    name: 'yellow',
    hex: '#ffeb3b',
    contrast: '#000'
  }
]
